import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LandingPageComponent } from './layout/landing-page/landing-page.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { LoaderComponent } from './layout/loader/loader.component';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { PageNotFoundComponent } from './layout/page-not-found/page-not-found.component';
import { AccessDeniedComponent } from './layout/access-denied/access-denied.component';
import { EventTrackingDirective } from './standalone/directives/event-tracking.directive';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LandingPageComponent,
    LoaderComponent,
    PageNotFoundComponent,
    AccessDeniedComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatIconModule,
    ToastrModule.forRoot({
        positionClass: 'toast-bottom-center',
        preventDuplicates: true
    }),
    RouterModule,
    NgbDropdownModule,
    EventTrackingDirective,
    CommonModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
],
  providers: [],
  bootstrap: [AppComponent, MsalRedirectComponent] 
})
export class AppModule { }
